import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getNoindexPageTitle, isNoindexRoute, PRIVATE_ROBOTS_DIRECTIVES } from '../utils/seoPolicy';

const RouteSeoPolicy: React.FC = () => {
    const location = useLocation();
    const noindex = isNoindexRoute(location.pathname);

    useLayoutEffect(() => {
        document.head
            .querySelectorAll('[data-tc-route-seo="true"]')
            .forEach((tag) => tag.remove());

        if (!noindex) {
            return;
        }

        document.head
            .querySelectorAll([
                '[data-default-seo="true"]',
                'link[rel="canonical"]',
                'script[type="application/ld+json"]',
                'meta[property^="og:"]',
                'meta[name^="twitter:"]',
            ].join(','))
            .forEach((tag) => tag.remove());

        document.title = getNoindexPageTitle(location.pathname);
        for (const name of ['robots', 'googlebot', 'bingbot']) {
            const meta = document.createElement('meta');
            meta.name = name;
            meta.content = PRIVATE_ROBOTS_DIRECTIVES;
            meta.dataset.tcRouteSeo = 'true';
            meta.dataset.tcSeoRuntime = 'true';
            document.head.appendChild(meta);
        }

        return () => {
            document.head
                .querySelectorAll('[data-tc-route-seo="true"]')
                .forEach((tag) => tag.remove());
        };
    }, [location.pathname, noindex]);

    return null;
};

export default RouteSeoPolicy;
